<template>
  <div class="single-counter d-flex justify-content-between flex-wrap align-items-center mb-30">
    <i class="far fa-lightbulb fade" v-if="!loading"></i>
    <div class="c-number fade" v-if="!loading">
      <h3 class="counter">
        {{ contador }}
        <small>NCM</small>
      </h3>
      <span>Em monitoramento</span>
    </div>

    <div class="spinner-border text-primary m-auto" role="status" v-else>
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>

<script>
import service from "../../services/ServiceMonitoramentoComp";
import serviceCookie from "../../services/ServiceCookie";
import { setTimeout } from "timers";
export default {
  props: {
    contador: ""
  },
  data() {
    return {
      loading: true,
      usuario: ""
    };
  },
  async created() {
    setTimeout(() => {
      if (this.contador >= 0) this.loading = false;
    }, 200);
  }
};
</script>

<style scoped>
@keyframes exibir {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.fade {
  animation-name: exibir;
  animation-direction: normal;
  animation-duration: 0.5s;
  animation-fill-mode: both;
}
</style>